var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#00ABAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#B3F8EB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5643 24L24.4356 24C23.56 24 23.1222 24 22.8191 24.2068C22.6689 24.3092 22.5449 24.4446 22.4566 24.6023C22.2784 24.9207 22.3219 25.3509 22.4091 26.2113C22.5545 27.6473 22.6272 28.3653 23.0079 28.8786C23.1976 29.1344 23.4382 29.3494 23.7148 29.5103C24.27 29.8333 25.0007 29.8333 26.4622 29.8333L41.5377 29.8333C42.9992 29.8333 43.73 29.8333 44.2851 29.5103C44.5618 29.3494 44.8023 29.1344 44.992 28.8786C45.3728 28.3653 45.4455 27.6473 45.5909 26.2113C45.678 25.3509 45.7216 24.9207 45.5434 24.6023C45.4551 24.4446 45.331 24.3092 45.1809 24.2068C44.8777 24 44.4399 24 43.5643 24Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.833L23.5 35.714C23.5 40.0913 23.5 42.28 24.8668 43.6398C26.2337 44.9997 28.4336 44.9997 32.8333 44.9997H35.1667C39.5664 44.9997 41.7663 44.9997 43.1332 43.6398C44.5 42.28 44.5 40.0913 44.5 35.714V29.833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 33.333H36.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.be916fbedf41212c6dd6e6dd278f00d3.svg";
export { ForwardRef as ReactComponent };